import { ArrowIconButton } from '@app/components/Calendars/components/ArrowIconButton';
import { CV_PREFIX } from '@app/components/Calendars/components/CalendarView/constants';
import { DayNumber } from '@app/components/Calendars/components/DayNumber';
import type { NCalendars } from '@app/components/Calendars/types';
import '@app/components/Calendars/components/Header/styles/Header.desktop.scss';

export const Header: NCalendars.HeaderType = ({
  toPrevDate,
  toNextDate,
  dayHumbers,
  smallButtons = false,
}) => (
  <div className={`${CV_PREFIX}-header`}>
    <div className="arrow-container-left" data-small={smallButtons}>
      <ArrowIconButton isVisible direction="left" onClick={toPrevDate} />
    </div>
    <div
      className="center-container"
      data-calendar={dayHumbers.length === 1 ? 'daily' : 'weekly'}
    >
      {dayHumbers.map((dayNumber) => (
        <DayNumber
          key={`${dayNumber.dayNumber}_${dayNumber.title}`}
          {...dayNumber}
        />
      ))}
    </div>
    <div className="arrow-container-right" data-small={smallButtons}>
      <ArrowIconButton isVisible direction="right" onClick={toNextDate} />
    </div>
  </div>
);
